import React, { useContext, useState, createContext, useMemo } from 'react';

type LoginRedirectPathContext = {
  redirectPath: string | null;
  setRedirectPath: (path: string | null) => void;
};

const loginRedirectPathContext = createContext<LoginRedirectPathContext | null>(
  null,
);

export const useLoginRedirectPathContext = () => {
  const context = useContext(loginRedirectPathContext);
  if (context === null) {
    throw new Error('LoginRedirectPathContext must be present');
  }

  return context;
};

const LoginRedirectPathProvider: React.FC = ({ children }) => {
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const value = useMemo(() => ({ redirectPath, setRedirectPath }), [
    redirectPath,
    setRedirectPath,
  ]);

  return (
    <loginRedirectPathContext.Provider value={value}>
      {children}
    </loginRedirectPathContext.Provider>
  );
};

export default LoginRedirectPathProvider;
